import { render, staticRenderFns } from "./ShowErrorAssignRevokeModal.vue?vue&type=template&id=553c813c&scoped=true"
import script from "./ShowErrorAssignRevokeModal.vue?vue&type=script&lang=js"
export * from "./ShowErrorAssignRevokeModal.vue?vue&type=script&lang=js"
import style0 from "./ShowErrorAssignRevokeModal.vue?vue&type=style&index=0&id=553c813c&prod&lang=scss&scoped=true"
import style1 from "./ShowErrorAssignRevokeModal.vue?vue&type=style&index=1&id=553c813c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c813c",
  null
  
)

export default component.exports